import { InputOptionBox, Button } from '../../../../core/components/Index';
import ApplyViewModel from './ApplyViewModel';
import { Appl } from '../../../../core/Appl';
import { useParams } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { Steps } from './ApplyModels';
import { observer } from 'mobx-react';
import Helper from '../../../../core/services/Helper';

const OptionSelectionMemberDeclaration = observer(() => {

  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  let { memberId } = useParams();
  useAsyncEffect(async () => {
    await vm.loadStepAsync(Steps.OptionSelectionMemberDeclaration, memberId!);
  }, []);

  // Get the selected option details with null checks
  const selectedOption = vm.model.lovOptionSelections?.find(
    o => o.id === vm.model.optionSelection?.beneficiaryPaymentOptionId
  );

  // Get full option name and description safely
  const getFullOptionName = () => {
    return Helper.formattedHtml(selectedOption?.name || '');
  };

  const getOptionDescription = () => {
    return Helper.formattedHtml(selectedOption?.confirmDescription || '');
  };

  return (
    <div className="space-y-6 max-w-4xl mb-6">
      <h1 className="text-32px tracking--1percent text-neutral-800 font-semibold mb-4">Option Election</h1>
      <p className="text-gray-700 font-medium text-22px">Member Declaration</p>
      <div className="flex items-start space-x-2">
        <InputOptionBox
          inputId="beneficiaryPaymentOptionDeclaration"
          value={vm.model.optionSelection?.beneficiaryPaymentOptionDeclaration}
          className="-mt-[0.45]"
          checked={vm.model.optionSelection?.beneficiaryPaymentOptionDeclaration || false}
          onChange={(e: any) => vm.onInputChange(e, 'beneficiaryPaymentOptionDeclaration', vm.model.optionSelection)}
        />
        <div className="flex-1">
          <label htmlFor="beneficiaryPaymentOptionDeclaration" className="text-black flex flex-col cursor-pointer rounded-lg text-15px">
            <span>{getFullOptionName()}</span>
            <span className="font-normal mt-2">
              {getOptionDescription()}
            </span>
          </label>
        </div>
      </div>
      <div className="flex mt-6 flex-wrap gap-2 sm:flex-nowrap">
        <Button title={`${vm.navigatedFromReviewScreen ? 'Save & Return to Review' : 'Save & Continue'}`}
          rounded disabled={!vm.model.optionSelection?.beneficiaryPaymentOptionDeclaration}
          onClick={async () => await vm.onOptionSelectionMemberDeclarationStepAsync()} />
        <Button label="Make a Change" severity="warning" outlined rounded
          onClick={() => vm.navigate('option-selection/select-your-option')}
          className="border-orange-500 text-orange-500 px-6 py-2 rounded-md hover:bg-orange-100"
        />
        {/* {vm.navigatedFromReviewScreen && <Button title="Cancel & Return to Review" severity='secondary' rounded
          onClick={async () => await vm.navigateToReviewStepAsync()}
        />} */}
      </div>
    </div>
  );
});

export default OptionSelectionMemberDeclaration;
